export default __webpack_public_path__ + "static/media/M34.ccc7f596.svg";